import { bindable } from 'aurelia-framework';

class JobsContainer {
  @bindable selectedAccount = null;
  @bindable refresh = false;
  @bindable cancelledJob = null;
  @bindable finishedJob = null;
  @bindable onViewJob = () => {};
  @bindable onNewJobRequest = () => {};
  loading = false;
  tableColumns = [
    {
      id: 'title',
      title: 'Date',
      sortEnabled: true,
    },
    {
      id: 'type',
      title: 'Job',
      sortEnabled: false,
    },
    {
      id: 'variant',
      title: 'Variant',
      sortEnabled: false,
    },
    {
      id: 'status',
      title: 'Status',
      sortEnabled: false,
    },
    {
      id: 'actions',
      title: 'Actions',
      sortEnabled: false,
    },
  ];
  tableActions = [
    {
      id: 'view',
      title: 'View',
    },
  ];
  list = null;
  /**
   * @param {AppErrorPublisher} appErrorPublisher To publish errors to the UI.
   * @param {errorParser}       errorParser       Used for error parsing.
   * @param {ProductFeedsJobs}  productFeedsJobs  To get the jobs.
   */
  constructor(appErrorPublisher, errorParser, productFeedsJobs) {
    'inject';

    this._appErrorPublisher = appErrorPublisher;
    /**
     * The parser the container will use to format possible errors.
     * @type {ParserrorWrapper}
     * @access protected
     * @ignore
     */
    this._jobsErrorParser = errorParser.wrap();
    this._productFeedsJobs = productFeedsJobs;
  }
  cancelledJobChanged(newValue, previousValue) {
    if (
      newValue &&
      this.list &&
      (!previousValue || newValue !== previousValue)
    ) {
      this.list.cancelJob(newValue);
    }
  }
  changeSort(column) {
    let asc = true;
    if (this.list.sortBy === column) {
      asc = !this.list.sortAsc;
    }

    this.list.sort(column, asc);
    return this.list.loadJobs()
    .catch((error) => {
      const parsedError = this._jobsErrorParser(error, 'There was an error loading the jobs');

      this._appErrorPublisher.notify(error, parsedError.message);
    });
  }
  finishedJobChanged(newValue, previousValue) {
    if (
      newValue &&
      this.list &&
      (!previousValue || newValue.id !== previousValue.id)
    ) {
      this.list.changeJobStatus(newValue.id, newValue.status);
    }
  }
  moveToTheNextPage() {
    this.list.moveToTheNextPage()
    .catch((error) => {
      const parsedError = this._jobsErrorParser(error, 'There was an error loading the jobs');

      this._appErrorPublisher.notify(error, parsedError.message);
    });
  }
  moveToThePreviousPage() {
    this.list.moveToThePreviousPage()
    .catch((error) => {
      const parsedError = this._jobsErrorParser(error, 'There was an error loading the jobs');

      this._appErrorPublisher.notify(error, parsedError.message);
    });
  }
  refreshChanged(currentValue, previousValue) {
    if (this.list && !previousValue && currentValue) {
      this.list.reset();
      this._loadList();
    }
  }
  selectedAccountChanged() {
    this.list = this._productFeedsJobs.newList(this.selectedAccount.id);
    this._loadList();
  }
  _loadList() {
    this.list.loadJobs()
    .catch((error) => {
      const parsedError = this._jobsErrorParser(error, 'There was an error loading the jobs');

      this._appErrorPublisher.notify(error, parsedError.message);
    });
  }
}

export { JobsContainer };
